module.exports = __webpack_public_path__ + "static/media/HPSimplifiedW01-Regular.014b41b0.woff";